import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { IAmostraModel } from 'src/app/models/amostra.model';
import { IEnumModel } from 'src/app/models/enum.model';
import { AmostraService } from 'src/app/services/amostra.service';
import { InserirAmostraComponent } from 'src/app/shared/components/aba-amostra/inserir-amostra/inserir-amostra.component';
import { ModalAmostraFormularioComponent } from 'src/app/shared/components/aba-amostra/modal-amostra-formulario/modal-amostra-formulario.component';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-folha-testes',
  templateUrl: './folha-testes.component.html',
  styleUrls: ['./folha-testes.component.scss']
})
export class FolhaTestesComponent extends BaseFormComponent implements OnInit {

  displayedColumns: string[] = [
    "nome",
    "amostra",
    "ug",
    "questoes",
    "acoes",
  ];

  dataSource = new MatTableDataSource<IAmostraModel>([]);
  semDados = true;
  amostra: IAmostraModel = {} as IAmostraModel;
  tipoAmostra!: string;
  tipoTrabalho: IEnumModel = {} as IEnumModel;

  @Input() visualizar: boolean;
  @Input() hiddenEdicao: boolean;
  @Input() planejamentoId: number;
  @Input() numeroOpa: string;
  @Input() statusPlanejamento: number;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("tabela1") public tabela1: MatSort;

  constructor(
    route: ActivatedRoute,
    toastr: ToastrService,
    router: Router,
    localeService: BsLocaleService,
    matDialog: MatDialog,
    private amostraService: AmostraService
  ) {
    super(route, toastr, router, localeService, matDialog);

    if (this.router.url.includes("planejamento")) {
      this.tipoAmostra = "planejamento";
      this.planejamentoId = this.id;
      this.tipoTrabalho.codigo = 7;
    }

    if (this.router.url.includes("osa")) {
      this.tipoAmostra = "osa";
    }

    if (this.router.url.includes("auditoria")) {
      this.tipoAmostra = "auditoria";
    }
  }

  ngOnInit(): void {
    this.visualizar =
      this.route.snapshot.routeConfig.path.includes("visualizar") ||
      this.route.snapshot.routeConfig.path.includes("osa");
    this.getAmostra(this.tipoAmostra);
  }

  extrairDados(dados: any[]): any[] {
    const resultado: any[] = [];

    let indiceFolha = 1;
    const programaTrabalhoMap = new Map<string, { questaoCount: number, amostraIds: Set<any> }>();

    for (const item of dados) {
      const questaoCount = item.planejamentoAmostraMatrizQuestoes?.length || 0;
      const amostraNome = item.nome;

      item.amostraUnidadeGestoras.forEach((ug) => {
        const indice = String(indiceFolha).padStart(2, '0');

        resultado.push({
          id: item.id,
          indice,
          nome: `Folha Teste - ${indice}`,
          amostra: amostraNome,
          questoes: questaoCount <= 1 ? 'Q01' : `Q01 a Q${String(questaoCount).padStart(2, '0')}`,
          ug: ug.unidadeGestora.sigla,
          tipo: 1 // Amostra
        });

        const sigla = ug.unidadeGestora.sigla;
        if (!programaTrabalhoMap.has(sigla)) {
          programaTrabalhoMap.set(sigla, { questaoCount: 0, amostraIds: new Set<any>() });
        }

        const grupo = programaTrabalhoMap.get(sigla)!;
        grupo.questaoCount += questaoCount;
        grupo.amostraIds.add(item.id);

        indiceFolha++;
      });
    }

    // 2. Gerar "Programa de trabalho" agrupado por UG
    let indicePrograma = 1;
    for (const [sigla, grupo] of programaTrabalhoMap.entries()) {
      const indice = String(indicePrograma).padStart(2, '0');
      const totalQuestoes = grupo.questaoCount;
      const questaoTexto = totalQuestoes <= 1
        ? 'Q01'
        : `Q01 a Q${String(totalQuestoes).padStart(2, '0')}`;

      // Obter nomes das amostras a partir dos IDs
      const nomesAmostras = dados
        .filter(item => grupo.amostraIds.has(item.id))
        .map(item => item.nome)
        .join(', ');

      resultado.push({
        id: Array.from(grupo.amostraIds),
        indice,
        nome: `Programa de trabalho - ${indice}`,
        amostra: nomesAmostras,
        questoes: questaoTexto,
        ug: sigla,
        tipo: 2 // Programa de Trabalho
      });

      indicePrograma++;
    }

    return resultado;
  }




  getAmostra(tipoAmostra: any) {
    this.amostraService
      .obterAmostra(this.id, tipoAmostra)
      .then((res) => {
        if (res.sucesso) {
          this.dataSource = new MatTableDataSource<any>(
            this.extrairDados(res.dados)
          );

          this.dataSource._updateChangeSubscription();

          this.dataSource.sortingDataAccessor = (
            item: any,
            property
          ) => {
            switch (property) {
              case "nome":
                return item?.nome;
              case "ug":
                return item?.amostraUnidadeGestoras[0]
                  .unidadeGestora.sigla;
              default:
                return item[property];
            }
          };

          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.tabela1;
          this.semDados = this.dataSource.filteredData.length === 0;
        } else {
          this.dataSource = new MatTableDataSource<IAmostraModel>([]);
          this.dataSource._updateChangeSubscription();
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.tabela1;
          this.semDados = true;
          Swal.fire({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            icon: "warning",
            title: "Atenção",
            text: res.mensagem.descricao,
          });
        }
      })
      .catch((err) => {
        this.exibirMensagemAlerta(err.mensagem.descricao);
      })
  }

  exibir(element: any) {
    if (element.tipo == 1) {
      this.router.navigate([`planejamento/${this.id}/planejar/folhas-testes/imprimir`], {
        state: {
          idAmostra: element.id,
          indice: element.indice,
          numeroOpa: this.numeroOpa,
          nomeFolhaTeste: element.nome
        }
      })
    } else if (element.tipo == 2) {
      this.router.navigate([`planejamento/${this.id}/planejar/programa-trabalho/imprimir`], {
        state: {
          idAmostra: element.id,
          indice: element.indice,
          numeroOpa: this.numeroOpa,
          nomeFolhaTeste: element.nome
        }
      })
    }
  }

}
